import React from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { Assessment1FuelTypeInfo } from "../state";


interface Assessment1DownloadCSVProps {
    fuelTypes: Assessment1FuelTypeInfo[];
}

function Assessment1DownloadCSV({ fuelTypes }: Assessment1DownloadCSVProps) {

    
    const csvData = [["Fuel", "Issue", "Action Plan"]];
        let rowIndex:number = 1;
        //iterate fuel types
        fuelTypes.map(fuel => {
            if(fuel.IncludingEnergyUseChargesFlag === false)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Expenditure amounts reported vendors should include energy usage charges"
                                      , fuel.IncludingEnergyUseChargesDesc];
                rowIndex++; 
            }
            if(fuel.IncludingEnergyDeliveryChargesFlag === false)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Expenditure amounts reported vendors should include include delivery, fixed charges, and taxes."
                                      , fuel.IncludingEnergyDeliveryChargesDesc];
                rowIndex++; 
            }
            if(fuel.IncludingEnergyOptionalChargesFlag === true)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Expenditure amounts reported by vendors should NOT include optional charges."
                                      , fuel.IncludingEnergyOptionalChargesDesc];
                rowIndex++; 
            }
            if(fuel.Including12MonthOnlyFlag === false)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Vendors should be reporting for a 12 month period only."
                                      , fuel.Including12MonthOnlyDesc];
                rowIndex++; 
            }
            if(fuel.IncludingComplete12MonthFlag === false)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Vendors should be reporting for a full 12 month period."
                                      , fuel.IncludingComplete12MonthDesc];
                rowIndex++; 
            }
            if(fuel.IndicatingLessThan12MonthFlag === false)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"If a client`s expenditure data represents less than 12-months for any reason, this needs to be indicated and accounted when calculating your average expenditures."
                                      , fuel.IndicatingLessThan12MonthDesc];
                rowIndex++; 
            }
            if(fuel.ReportingAfterDiscountsFlag === false)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Vendors should be sending billing data after low-income discounts have been applied."
                                      , fuel.ReportingAfterDiscountsDesc];
                rowIndex++; 
            }
        });
    return (
      <CSVLink data={csvData} filename="MainHeatingFuelAssessment1.csv" className="dataButton">Download as CSV</CSVLink>
    );
}


export default Assessment1DownloadCSV;
